// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__33LcH","colCheckbox":"styles_colCheckbox__3ccQ5"};